export * from './tmIf.directive';
